/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useNavigate } from "react-router";

import { useHomeRoute } from "@/routes/hooks/useHomeRoute";
import Typography from "@mui/material/Typography";

import { CloseIcon, colors } from "@dotnet/telematics-design-system";

import { useMediaQueries } from "../../../../../../../../shared";
import Button, {
  BUTTON_COLORS,
  BUTTON_SIZES,
  BUTTON_VARIANTS
} from "../../../../../../../Button/Button";
import Logo from "../../../../../../../Logo/Logo";
import { useStyles } from "../../../../../../styles";

interface ICompanySelectorTopControlsProps {
  close: () => void;
  boxPadding: string;
  itemName: string;
}

const CompanySelectorTopControls = ({
  close,
  boxPadding,
  itemName
}: ICompanySelectorTopControlsProps) => {
  const { toMd, fromMd } = useMediaQueries();

  const navigate = useNavigate();
  const { homeRoute } = useHomeRoute();

  const { companySelectorTopLogo, navbarItemTopControls } = useStyles();

  const handleLogoClick = () => {
    navigate(homeRoute);
    close();
  };

  return (
    <>
      {toMd && (
        <div css={css(companySelectorTopLogo)}>
          <Logo
            css={css({
              cursor: "pointer"
            })}
            onClick={handleLogoClick}
          />
        </div>
      )}

      <div
        id="desktop-company-selector"
        css={css([
          {
            padding: boxPadding
          },
          navbarItemTopControls
        ])}
      >
        <Typography
          variant="h6"
          sx={{ color: colors.textDark, alignSelf: "flex-end" }}
        >
          {itemName}
        </Typography>

        {fromMd && (
          <Button
            id="controlsItemFrameBtn"
            variant={BUTTON_VARIANTS.IconOnly}
            size={BUTTON_SIZES.Small}
            color={BUTTON_COLORS.White}
            icon={<CloseIcon />}
            onClick={close}
          />
        )}
      </div>
    </>
  );
};

export default CompanySelectorTopControls;
